export const MEDIA_LG = 991
export const MEDIA_SM = 500
